import { useField } from 'formik';
import FieldWrapper, { FieldWrapperProps } from '../FieldWrapper';
import RawRadioGroup from '../RawRadioGroup';

type Props = {
  options: { label: string; value: string; disabled?: boolean }[];
  optionsInRow?: boolean;
  disabled?: boolean;
  tooltipContent?: string;
} & Omit<FieldWrapperProps, 'children'>;
export default function RadioGroup({
  name,
  labelClass,
  labelText,
  required,
  containerClass,
  description,
  options,
  optionsInRow = false,
  disabled = false,
  tooltipContent,
}: Props) {
  const [field, _meta, helpers] = useField({ name });
  return (
    <FieldWrapper
      {...{ description, name, labelClass, containerClass, labelText, required, tooltipContent }}
    >
      <RawRadioGroup
        options={options}
        optionsInRow={optionsInRow}
        onChange={event => {
          helpers.setValue(event.target.value);
          helpers.setTouched(true);
        }}
        name={name}
        value={field.value}
        disabled={disabled}
      />
    </FieldWrapper>
  );
}
